/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import styled from "styled-components";
import { X } from "lucide-react";
import FormNuevaNP from "./FormNuevaOV";

const Title = styled.h3`
  color: #293134;
  text-align: center;
  font-family: Nunito;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.6px;
`;
const Header = styled.div`
  padding: 15px;
  padding-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
`;

const NuevaOrdenDeVentaModal = ({ history, toggle, isOpen, reloadOrdenesDeVenta, ordenData }) => {
  const [fullSize, setFullSize] = useState(false);
  return (
    <Modal
      isOpen={isOpen}
      style={{
        fontFamily: "Nunito",
        ...(fullSize && { maxWidth: "1100px" }),
      }}
      size="lg"
      centered
    >
      <Header>
        <Title>{ordenData ? `Orden de venta: ${ordenData.idOrdenDeVenta}` : "Nueva Orden de Venta"}</Title>
        <X onClick={() => toggle(!!ordenData)} style={{ cursor: "pointer" }} />
      </Header>
      <ModalBody style={{ borderRadius: "4px", paddingTop: "0px" }}>
        <FormNuevaNP toggle={toggle} history={history} reloadOrdenesDeVenta={reloadOrdenesDeVenta} setFullSize={setFullSize} ordenData={ordenData} />
      </ModalBody>
    </Modal>
  );
};

export default NuevaOrdenDeVentaModal;
